import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70857cdd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "orangehrm-background-container" }
const _hoisted_2 = { class: "orangehrm-card-container ffj-signing" }
const _hoisted_3 = { class: "ffj-signing__header" }
const _hoisted_4 = { class: "orangehrm-main-title" }
const _hoisted_5 = {
  key: 0,
  class: "ffj-signing__metadata",
  "data-testid": "ffj-signing-metadata"
}
const _hoisted_6 = { class: "ffj-signing__metadata-item" }
const _hoisted_7 = { class: "ffj-signing__metadata-label" }
const _hoisted_8 = {
  class: "ffj-signing__metadata-value",
  "data-testid": "ffj-signing-employee-name"
}
const _hoisted_9 = { class: "ffj-signing__metadata-item" }
const _hoisted_10 = { class: "ffj-signing__metadata-label" }
const _hoisted_11 = {
  class: "ffj-signing__metadata-value",
  "data-testid": "ffj-signing-period"
}
const _hoisted_12 = { class: "ffj-signing__metadata-item" }
const _hoisted_13 = { class: "ffj-signing__metadata-label" }
const _hoisted_14 = {
  key: 0,
  class: "ffj-signing__loading"
}
const _hoisted_15 = {
  key: 1,
  class: "ffj-signing__error",
  role: "alert",
  "data-testid": "ffj-signing-error"
}
const _hoisted_16 = {
  key: 2,
  class: "ffj-signing__body"
}
const _hoisted_17 = {
  key: 0,
  class: "ffj-signing__signed-info",
  "data-testid": "ffj-signing-signed-info"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 1,
  class: "ffj-signing__form",
  "data-testid": "ffj-signing-form"
}
const _hoisted_21 = { class: "ffj-signing__comment-field" }
const _hoisted_22 = { for: "manager-comment" }
const _hoisted_23 = ["placeholder"]
const _hoisted_24 = { class: "ffj-signing__ack-field" }
const _hoisted_25 = { for: "signing-ack" }
const _hoisted_26 = {
  key: 0,
  class: "ffj-signing__form-error",
  role: "alert",
  "data-testid": "ffj-signing-form-error"
}
const _hoisted_27 = {
  key: 1,
  class: "ffj-signing__form-success",
  "data-testid": "ffj-signing-form-success"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_button = _resolveComponent("oxd-button")!
  const _component_oxd_divider = _resolveComponent("oxd-divider")!
  const _component_monthly_grid = _resolveComponent("monthly-grid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("h6", _hoisted_4, _toDisplayString(_ctx.$t('forfait_jours.manager_signing_title')), 1),
          (_ctx.declaration)
            ? (_openBlock(), _createElementBlock("dl", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("dt", _hoisted_7, _toDisplayString(_ctx.$t('general.employee_name')), 1),
                  _createElementVNode("dd", _hoisted_8, _toDisplayString(_ctx.employeeName), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("dt", _hoisted_10, _toDisplayString(_ctx.$t('forfait_jours.month_selector_label')), 1),
                  _createElementVNode("dd", _hoisted_11, _toDisplayString(_ctx.periodLabel), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("dt", _hoisted_13, _toDisplayString(_ctx.$t('forfait_jours.status_label')), 1),
                  _createElementVNode("dd", {
                    class: _normalizeClass(["ffj-signing__status", `ffj-signing__status--${_ctx.declaration.status.toLowerCase()}`]),
                    "data-testid": "ffj-signing-status"
                  }, _toDisplayString(_ctx.statusLabel), 3)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_oxd_button, {
          "display-type": "ghost",
          label: _ctx.$t('forfait_jours.manager_signing_back_to_roster'),
          type: "button",
          "data-testid": "ffj-signing-back",
          onClick: _ctx.onBack
        }, null, 8, ["label", "onClick"])
      ]),
      _createVNode(_component_oxd_divider),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t('general.loading')), 1))
        : (_ctx.loadError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.loadError), 1))
          : (_ctx.declaration)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                (_ctx.declaration.status === 'SIGNED')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('forfait_jours.status_signed')), 1),
                      (_ctx.declaration.managerSignedName)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.$t('general.signed_by')) + ": " + _toDisplayString(_ctx.declaration.managerSignedName), 1))
                        : _createCommentVNode("", true),
                      (_ctx.declaration.managerSignedAt)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.$t('general.date')) + ": " + _toDisplayString(_ctx.declaration.managerSignedAt), 1))
                        : _createCommentVNode("", true),
                      _createVNode(_component_oxd_button, {
                        "display-type": "secondary",
                        label: _ctx.$t('forfait_jours.download_signed_pdf'),
                        type: "button",
                        "data-testid": "ffj-signing-download-pdf",
                        onClick: _ctx.onDownloadPdf
                      }, null, 8, ["label", "onClick"])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_monthly_grid, {
                  days: _ctx.orderedDays,
                  editable: false
                }, null, 8, ["days"]),
                (_ctx.declaration.status === 'SUBMITTED')
                  ? (_openBlock(), _createElementBlock("section", _hoisted_20, [
                      _createVNode(_component_oxd_divider),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('forfait_jours.manager_signing_comment_label')), 1),
                        _withDirectives(_createElementVNode("textarea", {
                          id: "manager-comment",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.managerComment) = $event)),
                          class: "ffj-signing__textarea",
                          placeholder: 
                _ctx.$t('forfait_jours.manager_signing_comment_placeholder')
              ,
                          "data-testid": "ffj-signing-comment",
                          rows: "4"
                        }, null, 8, _hoisted_23), [
                          [_vModelText, _ctx.managerComment]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _withDirectives(_createElementVNode("input", {
                          id: "signing-ack",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.acknowledged) = $event)),
                          type: "checkbox",
                          class: "ffj-signing__checkbox",
                          "data-testid": "ffj-signing-ack"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.acknowledged]
                        ]),
                        _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('forfait_jours.manager_signing_ack_label')), 1)
                      ]),
                      (_ctx.formError)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_ctx.formError), 1))
                        : _createCommentVNode("", true),
                      (_ctx.formSuccess)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(_ctx.$t('forfait_jours.manager_signing_success')), 1))
                        : _createCommentVNode("", true),
                      _createVNode(_component_oxd_button, {
                        "display-type": "secondary",
                        label: _ctx.$t('forfait_jours.manager_signing_submit'),
                        type: "button",
                        disabled: _ctx.isSubmitting,
                        "data-testid": "ffj-signing-submit",
                        onClick: _ctx.onSign
                      }, null, 8, ["label", "disabled", "onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
    ])
  ]))
}